import { render, staticRenderFns } from "./outDetailList.vue?vue&type=template&id=67d66e7c&"
import script from "./outDetailList.vue?vue&type=script&lang=js&"
export * from "./outDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports